export const getReleaseNotesSendRequestParams = ({
  auth,
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = {
    org: `${apiBaseUrl}/firmware/releaseNote.read`,
    site: `${apiBaseUrl}/sites/:siteId/firmware/releaseNote.read`
  };
  const apiKey = apiPaths[auth.scopeLevel];

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiKey,
    restfulParams
  };
}

export const getReleaseNoteCleanPayload = ({ selectedTargetFirmware }) => {
  return {
    firmwareId: selectedTargetFirmware?.id,
  }
}

export const initTargetFWList = ({
  selectedFW,
  isFromSupportListModal
}) => {
  const fwList = selectedFW.firmwareList.map((fw, index) => {
    const prefix = index === 0 ? " (Latest)" : "";
    const key = isFromSupportListModal ? "version" : "targetFirmwareVersion";

    return {
      ...fw,
      label: fw.version + prefix,
      value: fw.version,
      isSelected: selectedFW?.[key] ? selectedFW[key] === fw.version : index === 0
    }
  })

  return fwList;
}